import React from 'react';
import isEqual from 'lodash/isEqual';
import Button, { ButtonVariantType } from '@dealroadshow/uikit-button';
import styles from './sidebar.module.scss';

interface IProps {
  className?: string,
  innerRef?: React.ReactNode,
  filters?: {},
  appliedFilters?: {},
  initialFilters?: {},
  onApply?: () => void,
  onReset?: () => void,
  onTagRemove?: (fieldName: string, value: any) => void,
  tagsComponent?: React.ReactNode | {} | (() => React.ReactNode),
}

const Footer = React.forwardRef(({
  tagsComponent: TagsComponent,
  className = styles.footerContent,
  initialFilters,
  filters,
  appliedFilters,
  innerRef,
  onTagRemove,
  onApply,
  onReset,
}: IProps, ref) => {
  const isApplyDisabled = isEqual(filters, appliedFilters) ||
      (isEqual(initialFilters, appliedFilters)
          && isEqual(initialFilters, filters));
  const isResetDisabled =
      (isEqual(initialFilters, appliedFilters)
          && isEqual(initialFilters, filters));

  return (
    <div
      className={ className }
      // @ts-ignore
      ref={ ref || innerRef }
      data-test="filtersFooter"
    >
      <div
        className={ styles.footerTags }
        data-test="tags"
      >
        { /* @ts-ignore */ }
        <TagsComponent
          filters={ filters }
          onTagRemove={ onTagRemove }
        />
      </div>
      <div
        className={ styles.footerActions }
        data-test="actions"
      >
        <Button
          variant={ ButtonVariantType.action }
          onClick={ isApplyDisabled ? () => {} : onApply }
          disabled={ isApplyDisabled }
          title="Apply"
          dataTest="applyFiltersButton"
        />
        <Button
          variant={ ButtonVariantType.text }
          onClick={ isResetDisabled ? () => {} : onReset }
          disabled={ isResetDisabled }
          title="Reset"
          dataTest="resetFiltersButton"
        />
      </div>
    </div>
  );
});

export default Footer;
